import SSWhiteText from "@core-components/title/components/SSWhiteText";
import { Text } from "@mantine/core";
import type { ReactNode } from "react";

interface IClientDashboardTitleProps {
  label: string;
  subHeader: string;
  icon: ReactNode;
}

const ClientDashboardTitle: React.FC<IClientDashboardTitleProps> = ({
  label,
  icon,
  subHeader,
}) => {
  return (
    <div className="flex items-center gap-4">
      <div className="flex size-16 h-16 min-w-16 items-center justify-center rounded-full bg-primary-client">
        {icon}
      </div>
      <div>
        <SSWhiteText fz={24} fw={600}>
          {label}
        </SSWhiteText>
        <Text c={"dimmed"} fz={14} className="font-inter">
          {subHeader}
        </Text>
      </div>
    </div>
  );
};

export default ClientDashboardTitle;
